<template>
  <section class="c-section c-section--panel-membresias">
    <div>
      <h2 class="sec-medium w-sbold fs-30 mb-4">
        Mi membresía
      </h2>
      <div class="row">
        <div class="col-12 col-md-8 col-lg-6">
          <div class="c-membership">
            <h2 class="sec-color fs-21 w-sbold mb-4 d-flex">
              <span class="fs-25 d-flex me-2">
                <Icon icon="ph:crown-light"/>
              </span>
              Membresía activa
            </h2>

            <b-skeleton-wrapper :loading="subscription.isLoading">
              <template #loading>
                <div class="row gy-2">
                  <div class="col-12">
                    <b-skeleton width="100%" height="100px"></b-skeleton>
                  </div>
                  <div class="col-12">
                    <b-skeleton height="30px"></b-skeleton>
                  </div>
                </div>
              </template>

              <template v-if="!userData.subscriber">
                <p class="c-membership__text mb-4">
                  No cuentas con una membresía activa
                </p>

                <router-link
                  to="/membresias"
                  class="c-button c-button--primary w-100"
                >
                  <p class="mb-0 text-center w-100">
                    Comprar una membresía
                  </p>
                </router-link>
              </template>
              <template v-else-if="subscription.data">
                <div class="c-membership__text flex-column mb-4">
                  <p class="text-center w-100 mb-0 sec-medium fs-21 w-sbold">
                    Agro Club Premium - {{subscription.data.plan_name}}
                  </p>
                  <p class="mb-0 text-center w-100 pri-member fs-25 fs-md-30 w-sbold">
                    $ {{subscription.data.next_charge_amount}}/
                    {{(subscription.data.plan === 'month') ? 'mes' : 'año'}}
                  </p>
                  <p class="mb-0 text-center w-100 sec-medium fs-14 w-regular">
                    Termina en {{subscription.data.expired_at.days}} días
                  </p>
                </div>

                <p class="fs-16 w-regular sec-medium mb-4">
                  <template v-if="subscription.data.recurrency">
                    Tu membresía anual se renovará automaticamente el
                    <span class="w-sbold">
                      {{recurrencyNextCharge}}
                    </span>
                  </template>
                  <template v-else>
                    Tu membresía culminará el dia
                    <span class="w-sbold">
                      {{expiredDate}}
                    </span>
                  </template>
                </p>
                <div v-if="subscription.data.recurrency">
                  <button
                    class="bg-white border-0 sec-light"
                    @click="$bvModal.show('modalCancelAuto')"
                  >
                    Cancelar renovación automática
                  </button>
                </div>
              </template>
            </b-skeleton-wrapper>
          </div>
        </div>
      </div>
    </div>

  <b-modal
    id="modalCancelAuto"
    hide-footer
    hide-header
    hide-actions
    size="md"
    centered
    :no-close-on-backdrop="true"
  >
    <div class="c-modal-cancel-auto">
      <h2 class="sec-medium fs-25 w-sbold text-center">
        Cancelar renovación automática
      </h2>
      <p class="sec-medium fs-16 w-regular text-center">
        Recuerda que al cancelar tu renovación automática para el siguiente
        periodo deberás volver a comprar una nueva membresía
      </p>
      <textarea
        v-model="deleteDialog.note"
        name=""
        id=""
        cols="30"
        rows="3"
        class="c-form-group__input w-100 mb-3"
        placeholder="Detalla tu motivo (opcional)">
      </textarea>
      <div class="c-hr c-hr--extra mb-4"></div>
      <div class="d-md-flex">
        <button
          class="c-button c-button--black-ghost me-4 w-100 mb-2 mb-md-0"
          @click="$bvModal.hide('modalCancelAuto')"
        >
          <p class="mb-0 w-100 text-center">
            Cerrar
          </p>
        </button>
        <button
          @click="cancelSubscription()"
          class="c-button c-button--alert w-100"
          :class="{'loading' : deleteDialog.isLoading}"
          :disabled="deleteDialog.isLoading"
        >
          <p class="mb-0 text-center w-100">
            Confirmar
            <span class="c-button__spinner ms-2">
              <Icon icon="eos-icons:loading" />
            </span>
          </p>
        </button>
      </div>
    </div>
  </b-modal>
  </section>
</template>

<script>
export default {
  data() {
    return {
      subscription: {
        data: null,

        isLoading: false,
        isDeleting: true,
      },

      deleteDialog: {
        note: '',

        isLoading: false,
      },
    };
  },
  computed: {
    userData() {
      return this.$store.getters.stateUser;
    },
    userAuthToken() {
      return this.$store.getters.token;
    },

    recurrencyNextCharge() {
      const recurrencyDate = this.subscription.data?.recurrency
        ? new Date(this.subscription.data?.recurrency.next_charge)
        : false;

      return recurrencyDate
        ? `${recurrencyDate.getDate()} ${recurrencyDate.toLocaleString('es-PE', { month: 'long' })} ${recurrencyDate.getFullYear()}`
        : '';
    },
    expiredDate() {
      const expiredDate = this.subscription.data?.expired_at
        ? new Date(this.subscription.data?.expired_at.date)
        : false;

      return expiredDate
        ? `${expiredDate.getDate()} ${expiredDate.toLocaleString('es-PE', { month: 'long' })} ${expiredDate.getFullYear()}`
        : '';
    },
  },
  created() {
    this.getSubscription();
  },
  methods: {
    getSubscription() {
      this.subscription.isLoading = true;

      fetch(`${process.env.VUE_APP_API}/users/${this.userData.id}/subscriptions`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.userAuthToken}`,
        },
      })
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          return res.text().then((text) => { throw new Error(text); });
        })
        .then((response) => {
          if (response.status) {
            this.subscription.data = response.data;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.subscription.isLoading = false;
        });
    },
    cancelSubscription() {
      this.deleteDialog.isLoading = true;

      fetch(`${process.env.VUE_APP_API}/users/${this.userData.id}/subscriptions`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.userAuthToken}`,
        },
        body: JSON.stringify({
          ...(this.deleteDialog.note && { note: this.deleteDialog.note }),
        }),
      })
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          return res.text().then((text) => { throw new Error(text); });
        })
        .then((response) => {
          if (response.status) {
            window.location.reload();
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.deleteDialog.isLoading = false;
        });
    },
  },
};
</script>
